module.exports = __webpack_public_path__ + "img/css.9bafb49b.svg";